import React from 'react';

// Compact contextual loader: a small spinner + short text, never a giant
// grey block or a bare text line replacing the whole page. Used for the
// brief moments where business/shop data genuinely isn't available yet —
// see src/contexts/BusinessContext.js for why this is now rare (cached for
// the session instead of refetched on every page).
export default function LoadingInline({ text = 'Chargement…' }) {
  return (
    <div role="status" style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '20px 0', color: '#64748b', fontSize: 14 }}>
      <span className="spinner" aria-hidden="true" />
      <span>{text}</span>
    </div>
  );
}
